import QRCodeComp from "react-qr-code";
import React, { useState, useEffect } from "react";

const QRCode = ({ link = '' }) => {
    // Ensure link is always a string, handling null/undefined cases
    const linkValue = link || '';
    // Initialize state to store window width
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
    // Update window width on resize
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      // Add event listener for resize
      window.addEventListener("resize", handleResize);
  
      // Cleanup event listener on component unmount
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
  
    // Calculate QR Code size based on window width
    const qrCodeSize = windowWidth < 768 ? 160 : 360;
  
    return <QRCodeComp size={qrCodeSize} value={linkValue} />;
};

export default QRCode;